import { Suspense, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// CUSTOM SETUP
import reportWebVitals from './reportWebVitals';

// CUSTOM COMPONENTS
import AppLoaderComponent from 'component/global/app-core/app-loader/app-loader-component';
import AppProvider from 'app/providers/AppProvider';
import App from 'app/App';

import './index.css';
import EventHandlerComponent from 'component/global/event-handler/event-handler-component';

// Initialize React basis;
const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <StrictMode>
    <Suspense fallback={<AppLoaderComponent />}>
      <AppProvider>
        <EventHandlerComponent />
        <App />
      </AppProvider>
    </Suspense>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
